import type { IconProps } from './types';

export const CheckCircleIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9951 2.70996C17.123 2.71002 21.2803 6.86719 21.2803 11.9951C21.2802 17.123 17.123 21.2802 11.9951 21.2803C6.86719 21.2803 2.71002 17.123 2.70996 11.9951C2.70996 6.86715 6.86715 2.70996 11.9951 2.70996ZM16.8369 7.94922C16.3749 7.57956 15.6997 7.65414 15.3301 8.11621L10.2646 14.4482L8.23828 12.9287C7.76492 12.5738 7.09331 12.6693 6.73828 13.1426C6.38324 13.616 6.47974 14.2875 6.95312 14.6426L9.80957 16.7861C10.2725 17.1334 10.9275 17.0494 11.2891 16.5977L17.0039 9.45508C17.3735 8.99313 17.2987 8.31892 16.8369 7.94922Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9951 2.70996C17.123 2.71002 21.2803 6.86719 21.2803 11.9951C21.2802 17.123 17.123 21.2802 11.9951 21.2803C6.86719 21.2803 2.71002 17.123 2.70996 11.9951C2.70996 6.86715 6.86715 2.70996 11.9951 2.70996ZM16.8369 7.94922C16.3749 7.57956 15.6997 7.65414 15.3301 8.11621L10.2646 14.4482L8.23828 12.9287C7.76492 12.5738 7.09331 12.6693 6.73828 13.1426C6.38324 13.616 6.47974 14.2875 6.95312 14.6426L9.80957 16.7861C10.2725 17.1334 10.9275 17.0494 11.2891 16.5977L17.0039 9.45508C17.3735 8.99313 17.2987 8.31892 16.8369 7.94922Z"
        fill={color}
      />
    </svg>
  );
};
